package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class EventWizardRequest(
    val title: String,
    val description: String,
    val mediaStorageFolder: String? = null,
    val status: String? = null,
    val photoDataUrls: List<String>,
    val mobilePhotoDataUrls: List<String> = emptyList(),
    val videoDataUrls: List<String>,
    val maxCapacity: Int? = null,
    val ticketPrice: Double? = null,
    val currency: String,
    val hiddenInfo: String? = null,
    val scheduleType: String? = null,
    val eventDate: String? = null,
    val eventEndDate: String? = null,
    val eventTime: String,
    val eventEndTime: String? = null,
    val timeZone: String,
    val selectedDaysOfWeek: List<Int> = emptyList(),
    val weeklyTime: String,
    val weeklyEndTime: String? = null,
    val selectedDaysOfMonth: List<Int> = emptyList(),
    val monthlyTime: String,
    // Legacy slot booking fields
    val slotDaysOfWeek: List<Int> = emptyList(),
    val slotStartTime: String,
    val slotEndTime: String,
    // New slot booking configuration
    val minSlotsPerBooking: Int? = null,
    val slotDurationMinutes: Int? = null,
    val slotDayConfigurations: List<DaySlotConfiguration>? = null,
    val online: Boolean,
    val locationName: String,
    val locationAddress: String,
    val locationCity: String,
    val locationCountry: String,
    val locationLatitude: Double? = null,
    val locationLongitude: Double? = null,
    val onlineLink: String,
    val enableCarpool: Boolean,
    val carpoolPaymentPerPerson: Double? = null,
    val enableGroupChat: Boolean = false,
    val requireContactInfo: Boolean = false,
    // AI Landing page generation
    val useAiLanding: Boolean = false,
    val landingDescription: String? = null,
    val enableLandingPage: Boolean = false
) {
    @Serializable
    data class DaySlotConfiguration(
        val dayOfWeek: Int, // 0-6 or 1-7
        val startTime: String, // HH:mm format
        val endTime: String // HH:mm format
    )
}
